import store from '../store/store';
/**
 * Returns the pop imap configuration object which is observable
 */
export default function getPopImapConfiguration() {
    return store;
}
//# sourceMappingURL=getPopImapConfiguration.js.map